import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './components/header/header.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LayoutComponent } from './components/layout/layout.component';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatMenuModule } from '@angular/material/menu';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MatTabsModule } from '@angular/material/tabs';
import { AddInventoryPopupComponent } from './modals/add-inventory-popup/add-inventory-popup.component';
import { AddNotePopupComponent } from './modals/add-note-popup/add-note-popup.component';
import { MatIconModule } from '@angular/material/icon';
import { ChangePackagingPopupComponent } from './modals/change-packaging-popup/change-packaging-popup.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { MatFormFieldModule } from '@angular/material/form-field';
import { AddNewPopupComponent } from './modals/add-new-popup/add-new-popup.component';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { ErrorMessageComponent } from './components/error-message/error-message.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ReportParametersComponent } from './modals/report-parameters/report-parameters.component';
import { WarningPopupComponent } from './modals/warning-popup/warning-popup.component';
import { NotificationPopupComponent } from './modals/notification-popup/notification-popup.component';
import { WarningOrderPopupComponent } from './modals/warning-order-popup/warning-order-popup.component';
import { PaymentPlanPopupComponent } from './modals/payment-plan-popup/payment-plan-popup.component';
import { MedCostPopupComponent } from './modals/med-cost-popup/med-cost-popup.component';
import { DeliveryStatusComponent } from './modals/delivery-status/delivery-status.component';
import { MatRadioModule } from '@angular/material/radio';
import { InvoiceComponent } from './modals/invoice/invoice.component';
import { SummaryComponent } from './modals/summary/summary.component';
import { AddGroupComponent } from './modals/add-group/add-group.component';
import { SenderInformationComponent } from './modals/sender-information/sender-information.component';
import { UnsaveChangesComponent } from './modals/unsave-changes/unsave-changes.component';
import { AddDeliveryPartnerComponent } from './modals/add-delivery-partner/add-delivery-partner.component';
import { DimensionWeightComponent } from './modals/dimension-weight/dimension-weight.component';
import { RenewRefillRequestComponent } from './modals/renew-refill-request/renew-refill-request.component';
import { UserNotificationPopupComponent } from './modals/user-notification-popup/user-notification-popup.component';
import { AddReasonPopupComponent } from './modals/add-reason-popup/add-reason-popup.component';
import { ShowReasonPopupComponent } from './modals/show-reason-popup/show-reason-popup.component';
import { MatInputModule } from '@angular/material/input';
import { ClickStopPropagation } from './directives/stopPropogation.directive';
import { BulkUpdateComponent } from './modals/bulk-update/bulk-update.component';
import { SalePaymentPlanPopupComponent } from './modals/sale-payment-plan-popup/sale-payment-plan-popup.component';
import { LowActivityReasonComponent } from './modals/low-activity-reason/low-activity-reason.component';
import { DoctorAppointmentStatusComponent } from './modals/doctor-appointment-status/doctor-appointment-status.component';
import { PexchangeStatusComponent } from './modals/pexchange-status/pexchange-status.component';
import { NgxMatTimepickerModule } from 'ngx-mat-timepicker';
import { MatChipsModule } from '@angular/material/chips';
import { ConfirmAddProgramComponent } from './modals/confirm-add-program/confirm-add-program.component';
import { AddUserDeleteReasonComponent } from './modals/add-user-delete-reason/add-user-delete-reason.component';
import { DeleteConfirmPopUpComponent } from './modals/delete-confirm-pop-up/delete-confirm-pop-up.component';
import { MwsCancelComponent } from './modals/mws-cancel/mws-cancel.component';
import { AddressMatchPopupComponent } from './modals/address-match-popup/address-match-popup.component';
import { MergeAccountPopupComponent } from './modals/merge-account-popup/merge-account-popup.component';
import { CoachingConfirmPopupComponent } from './modals/coaching-confirm-popup/coaching-confirm-popup.component';
import { VisitpaymentConfirmPopupComponent } from './modals/visitpayment-confirm-popup/visitpayment-confirm-popup.component';
import { PatientRemainModalComponent } from './modals/address-match-popup/patient-remain-modal/patient-remain-modal.component';
import { MatDialogModule } from '@angular/material/dialog';
import { ConfirmSelectUserComponent } from './modals/confirm-select-user/confirm-select-user.component';
import { DrugViewPopUpComponent } from './modals/drug-view-pop-up/drug-view-pop-up.component';
import { ConfirmTranferTenantRingComponent } from './modals/confirm-tranfer-tenant-ring/confirm-tranfer-tenant-ring.component';
import { DrugListPopUpComponent } from './modals/drug-list-pop-up/drug-list-pop-up.component';
import { ViewRingPrescriptionComponent } from './modals/view-ring-prescription/view-ring-prescription.component';
import { QuickAddUserRingComponent } from './modals/quick-add-user-ring/quick-add-user-ring.component';
import { ConfirmReqOrderComponent } from './modals/confirm-req-order/confirm-req-order.component';
import { UpdateRequestStatusComponent } from './modals/update-request-status/update-request-status.component';
import { ReqAddReasonComponent } from './modals/req-add-reason/req-add-reason.component';
import { UploadFaxDetailComponent } from './modals/upload-fax-detail/upload-fax-detail.component';
import { ViewRxDetailComponent } from './modals/view-rx-detail/view-rx-detail.component';
import { ClearRxPopUpComponent } from './modals/clear-rx-pop-up/clear-rx-pop-up.component';
import { PartialConfirmPopUpComponent } from './modals/partial-confirm-pop-up/partial-confirm-pop-up.component';
import { ReqCancelOrderComponent } from './modals/req-cancel-order/req-cancel-order.component';
import { ConfirmForPrescriberComponent } from './modals/confirm-for-prescriber/confirm-for-prescriber.component';
import { ConfirmAddRxComponent } from './modals/confirm-add-rx/confirm-add-rx.component';
import { ViewDrugNamesComponent } from './modals/view-drug-names/view-drug-names.component';
import { NeedCnfrmDialogComponent } from './modals/need-cnfrm-dialog/need-cnfrm-dialog.component';

@NgModule({
  declarations: [
    HeaderComponent,
    LayoutComponent,
    AddInventoryPopupComponent,
    AddNotePopupComponent,
    ChangePackagingPopupComponent,
    PaginationComponent,
    AddNewPopupComponent,
    ErrorMessageComponent,
    ReportParametersComponent,
    WarningPopupComponent,
    NotificationPopupComponent,
    WarningOrderPopupComponent,
    PaymentPlanPopupComponent,
    MedCostPopupComponent,
    DeliveryStatusComponent,
    InvoiceComponent,
    SummaryComponent,
    AddGroupComponent,
    SenderInformationComponent,
    UnsaveChangesComponent,
    AddDeliveryPartnerComponent,
    DimensionWeightComponent,
    RenewRefillRequestComponent,
    UserNotificationPopupComponent,
    AddReasonPopupComponent,
    ShowReasonPopupComponent,
    ClickStopPropagation,
    BulkUpdateComponent,
    SalePaymentPlanPopupComponent,
    LowActivityReasonComponent,
    DoctorAppointmentStatusComponent,
    PexchangeStatusComponent,
    ConfirmAddProgramComponent,
    AddUserDeleteReasonComponent,
    DeleteConfirmPopUpComponent,
    MwsCancelComponent,
    AddressMatchPopupComponent,
    MergeAccountPopupComponent,
    CoachingConfirmPopupComponent,
    VisitpaymentConfirmPopupComponent,
    PatientRemainModalComponent,
    ConfirmSelectUserComponent,
    DrugViewPopUpComponent,
    ConfirmTranferTenantRingComponent,
    DrugListPopUpComponent,
    ViewRingPrescriptionComponent,
    QuickAddUserRingComponent,
    ConfirmReqOrderComponent,
    UpdateRequestStatusComponent,
    ReqAddReasonComponent,
    UploadFaxDetailComponent,
    ViewRxDetailComponent,
    ClearRxPopUpComponent,
    PartialConfirmPopUpComponent,
    ReqCancelOrderComponent,
    ConfirmForPrescriberComponent,
    ConfirmAddRxComponent,
    ViewDrugNamesComponent,
    NeedCnfrmDialogComponent
  ],
  imports: [
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MatSidenavModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatMenuModule,
    MatTabsModule,
    MatIconModule,
    NgxPaginationModule,
    MatFormFieldModule,
    MatInputModule,
    CommonModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCheckboxModule,
    MatRadioModule,
    MatTooltipModule,
    MatDatepickerModule,
    NgxMatTimepickerModule,
    MatChipsModule,
    MatDialogModule
  ],
  exports: [
    PaginationComponent,
    ErrorMessageComponent,
    ClickStopPropagation
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CoreModule { }
